import { z } from 'zod';

import { serviceOrderTypes } from '#domain/ServiceOrder.ts';

import { CoordinateStopFormDataValidationSchema, error, StopFormDataValidationSchema } from './OrderFormValidation.ts';

const SERVICE_ORDER_TEXT_MAX_LENGTH = 255;

export const ServiceOrderFormSchema = z.object({
    serviceType: z.enum(serviceOrderTypes),
    company: z.string().max(SERVICE_ORDER_TEXT_MAX_LENGTH, error.LONG_STRING).optional(),
    description: z.string().min(1, error.SMALL_STRING).max(SERVICE_ORDER_TEXT_MAX_LENGTH, error.LONG_STRING),
    note: z.string().max(SERVICE_ORDER_TEXT_MAX_LENGTH, error.LONG_STRING).optional(),
    executionStop: StopFormDataValidationSchema,
});

export type ServiceOrderFormData = z.infer<typeof ServiceOrderFormSchema>;

export const CoordinateServiceOrderFormSchema = ServiceOrderFormSchema.extend({
    executionStop: CoordinateStopFormDataValidationSchema,
});
